import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MasterPageComponent } from './masterpage.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HeaderMenuComponent } from './components/header-menu/header-menu.component';
import { FooterMenuComponent } from './components/footer-menu/footer-menu.component';


@NgModule({
  declarations: [
    MasterPageComponent,
    NavMenuComponent,
    HeaderMenuComponent,
    FooterMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    MasterPageComponent,
    NavMenuComponent,
    HeaderMenuComponent,
    FooterMenuComponent
  ]
})
export class MasterModule { }
